import React from "react";
import Image from "components/image";
import { Swiper, SwiperSlide } from "components/swiper";
import { Navigation, Autoplay } from "swiper/modules";
import { ReactComponent as FiveStars } from "svgs/five-stars.svg";
import { ReactComponent as Arrow } from "svgs/small-right-arrow.svg";
import { scrollToElementById } from "helpers/scroll";
import { reviewsWidgetId } from "utils/constants";
import Link from "components/link";
import clsx from "clsx/lite";

const InstaGallery = ({ data }) => {
	const isFluid = data?.settings?.isFluid;
	const isSlider = data?.feeds?.length > 1;

	const swiperSettings = isSlider
		? {
			loop: data?.feeds?.length > 5,
			modules: [Navigation, Autoplay],
			autoplay: {
				delay: 100,
				disableOnInteraction: false,
			},
			speed: 8000,
			breakpoints: {
				320: {
					slidesPerView: 2,
				},
				420: {
					slidesPerView: 2,
				},
				680: {
					slidesPerView: 4,
				},
				768: {
					slidesPerView: 6,
					speed: 6000,
				},
				1000: {
					slidesPerView: 6,
					speed: 6000,
				}
			}
		}
		: {};

	return (
		<div className="insta-gallery">
			<div className="w-full standard-section-width">
				<div className={clsx("w-full flex flex-col gap-6")}>
					<div className={clsx("flex flex-col gap-4 items-center", isFluid && "px-4 xl:px-5")}>
						<h2 className="text-center xs:px-5 sm:px-0">{data.title}</h2>
						<div className="flex flex-col gap-1.5 items-center">
							{data.displayRating &&
								<Link
									to={data.ratingUrl}
									className="flex gap-1 items-center text-secondary cursor-pointer"
									onClick={() => !data.ratingUrl && scrollToElementById(reviewsWidgetId)}>
									<FiveStars /> 4.9 average - <span className=" font-semibold text-black">1,000+</span> Reviews
								</Link>
							}
							<p className="text-secondary text-center">{data.subtitle}</p>
						</div>
					</div>
					<div className="flex">
						<Swiper {...swiperSettings}>
							{data.feeds.map((feed, index) => (
								<SwiperSlide key={index} className="insta-gallery-item">
									<div className="flex flex-col gap-2">
										<Link isTargetBlank to={feed.permalink}
											className="flex flex-col gap-2 group" rel="noreferrer">
											<Image className="aspect-square" image={feed.post?.asset} alt={feed.post?.alt} />
											{feed.title &&
												<div className="flex justify-between">
													<p className="line-clamp-1">{feed.title}</p>
													<Arrow />
												</div>
											}
										</Link>
									</div>
								</SwiperSlide>
							))}
						</Swiper>
					</div>
				</div>
			</div>
		</div>
	);
};

export default InstaGallery;